export const handleAuthRedirect = () => {
  // キャッシュクリア
  localStorage.clear();
  sessionStorage.clear();
  
  // Cookieクリア
  document.cookie.split(";").forEach((c) => {
    document.cookie = c
      .replace(/^ +/, "")
      .replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/");
  });
  
  // index.htmlへリダイレクト
  window.location.href = '/';
};